export default [
  {
    title: 'QuickLinks',
    content: [
      {
        text: 'Advertise with BizClik',
        href: '/advertise'
      },
      {
        text: 'User Agreement',
        href: '/user-agreement'
      },
      {
        text: 'Privacy Policy',
        href: '/privacy-policy'
      }
    ]
  }
]
